import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import {socket} from "../../lib/socketio";
import _ from "lodash";
import {isAuthorized } from '../../lib/authorization';
import { createUserLog } from '../../lib/api';
import { useSelector } from 'react-redux';

const InterlockColumn = ({index, column, data, option}) => {
    const [tagdata, settagdata] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [isValidationError, setIsValidationError] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');

    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setIsValidationError(false);
        settagdata('');
        setOpen({...open, [id]: false});
    };

    const handleSubmit = (event, id) => {
        event.preventDefault();
        if (typeof tagdata === 'undefined' || tagdata === '') {
            setOpen({...open, [id]: false});
        } else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]: false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    }

    const handleChange = (event, value, id, min, max, display_id) => {
        event.preventDefault();
        if(event.target.value < min || event.target.value > max){
            setIsValidationError(true);
        }
        else{
            setIsValidationError(false);
            settagdata(event.target.value);
            if(!electronApp){
                setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [id]}) })
            }
        }

    }

    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <Grid columns={12} celled='internally' stackable padded style={styles.grid}>
                    {column[i][0].tag_display_subgroup === 'I STATE DIAGRAM' ?
                        ''
                        :
                        <>
                            <h1 align='center'>{column[i][0].tag_display_subgroup}</h1>
                            {column[i].map(r =>
                                <Grid.Column style={{color: '#04BFBF', fontWeight: 'bold'}}>
                                    <p style={styles.name}>{r.tag_display_name}</p>
                                    {r.tag_display_name === 'PAFC_TDP210A' || r.tag_display_name === 'PAFC_TDP130A' ?
                                        <Button
                                            key='button'
                                            content={data[r.id]}
                                            disabled/>
                                        :
                                        <Button
                                            key='button'
                                            content={data[r.id]}
                                            disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                            onClick={() => {
                                                setOpen({...open, [r.id]: true})
                                            }}/>
                                    }
                                    <Modal
                                        key={r.id}
                                        style={styles.width}
                                        open={open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen={handleOpen[r.id]}>
                                        <Modal.Header>Enter Value for {r.tag_display_name}</Modal.Header>
                                        <Modal.Content>
                                            <form autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                                <Input focus autoFocus placeholder='Value' style={styles.input}
                                                    name='Input change'
                                                    label={r.unit || ""}
                                                    labelPosition='right'
                                                    type='number'
                                                    step='0.001'
                                                    size='small'
                                                    min={r.min}
                                                    max={r.max}
                                                    error={isValidationError}
                                                    onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max, r.display_id)}
                                                    defaultValue={data[r.id]}
                                                />
                                            </form>
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button color='blue' content={'Ok'} disabled={isValidationError}
                                                    onClick={(event, value) => handleSubmit(event, r.id)}/>
                                            <Button
                                                key='button'
                                                content='Close'
                                                color='red'
                                                style={{marginLeft: '5px', marginTop: '10px'}}
                                                onClick={() => handleClose(r.id)}/>
                                        </Modal.Actions>
                                    </Modal>
                                    {r.unit}
                                </Grid.Column>
                            )}
                        </>
                    }
                </Grid>
           
        ))
    ))

    const gridColumn_small = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <Grid columns={7} celled='internally' stackable padded style={styles.grid}>
                    {column[i][0].tag_display_subgroup === 'I STATE DIAGRAM' ?
                        ''
                        :
                        <>
                            <h1 align='center'>{column[i][0].tag_display_subgroup}</h1>
                            {column[i].map(r =>
                                <Grid.Column style={{color: '#04BFBF', fontWeight: 'bold'}}>
                                    <p style={styles.name}>{r.tag_display_name}</p>
                                    {r.tag_display_name === 'PAFC_TDP210A' || r.tag_display_name === 'PAFC_TDP130A' ?
                                    // r.tag_display_name.slice(0, 8) === 'ANODCONF' ||  r.tag_display_name.slice(0, 6) === 'TDN200' 
                                        <Button
                                            key='button'
                                            content={data[r.id]}
                                            disabled/>
                                        :
                                        <Button
                                            key='button'
                                            content={data[r.id]}
                                            onClick={() => {
                                                setOpen({...open, [r.id]: true})
                                            }}/>
                                    }
                                    <Modal
                                        key={r.id}
                                        style={styles.width}
                                        open={open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen={handleOpen[r.id]}>
                                        <Modal.Header>Enter Value for {r.tag_display_name}</Modal.Header>
                                        <Modal.Content>
                                            <form autoComplete='off' onSubmit={(event, value) => handleSubmit(event, r.id)}>
                                                <Input focus autoFocus placeholder='Value' style={styles.input}
                                                    name='Input change'
                                                    label={r.unit || ""}
                                                    labelPosition='right'
                                                    type='number'
                                                    step='0.001'
                                                    size='small'
                                                    min={r.min}
                                                    max={r.max}
                                                    error={isValidationError}
                                                    onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max)}
                                                    defaultValue={data[r.id]}
                                                />
                                            </form>
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button color='blue' content={'Ok'} disabled={isValidationError}
                                                    onClick={(event, value) => handleSubmit(event, r.id)}/>
                                            <Button
                                                key='button'
                                                content='Close'
                                                color='red'
                                                style={{marginLeft: '5px', marginTop: '10px'}}
                                                onClick={() => handleClose(r.id)}/>
                                        </Modal.Actions>
                                    </Modal>
                                    {r.unit}
                                </Grid.Column>
                            )}
                        </>
                    }
                </Grid>
           
        ))
    ))

    return (
        <Grid.Row key={index} style={styles.row}>
            {option === 'small'? gridColumn_small : gridColumn }
        </Grid.Row>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    name: {
        color: 'yellow',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word'
    },
    header: {
        marginBottom: '15px',
        textAlign: 'center'
    },
    width: {
        maxWidth: '400px'
    },
    row: {
        maxWidth: '1600px',
        padding: '20',
        marginTop: '20px'
    }
};
export default React.memo(InterlockColumn);